module.exports = __webpack_public_path__ + "static/media/wallet.660fabf2.svg";